import { Shimmer } from "../../common/Loading.styles";

const InfiniteListPlaceholder = () => {
    return <Shimmer type="title" count={3} dark />;
};

export default InfiniteListPlaceholder;
